"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const merge_1 = tslib_1.__importDefault(require("lodash/merge"));
const omitBy_1 = tslib_1.__importDefault(require("lodash/omitBy"));
const addRemoveNonUpdatedStates_1 = require("../../helpers/addRemoveNonUpdatedStates");
const getILTProgressStatusFromCompletionStatus_1 = require("../../helpers/getILTProgressStatusFromCompletionStatus");
const entity_1 = require("../../type/entity");
const getEnrolmentOfContent_1 = tslib_1.__importDefault(require("../enrolment/getEnrolmentOfContent"));
const getContentType_1 = require("../getContentType");
const getState_1 = require("../getState");
const getStateInteraction_1 = require("../getStateInteraction");
const isEmptyObject_1 = tslib_1.__importDefault(require("../isEmptyObject"));
const validateUser_1 = require("../validateUser");
const filterNullItem = (item) => !!item;
const getOfferWithoutChildren = (offer) => omitBy_1.default(offer, (value, key) => value && key === 'children');
const addBaseFieldsToSession = (content, session) => {
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.CURRICULUM:
            return Object.assign({}, session, { modelType: 'curriculumSession' });
        case entity_1.ContentType.CHECKPOINT:
        case entity_1.ContentType.ILT:
            return Object.assign({}, session, { modelType: 'state' });
        default:
            return Object.assign({}, session, { modelType: 'session' });
    }
};
function convertToPeerQuestionMongoSession(peerQuestionIndex, userId, peerQuestion, peerReviewStateInteractions) {
    try {
        const reviewsReceived = [];
        peerReviewStateInteractions.forEach((interaction) => {
            let review = {
                reviewedBy: interaction.actorId
            };
            if (interaction.reviews && interaction.reviews.length > 0) {
                const reviewObject = {
                    review: Object.assign({}, interaction.reviews[peerQuestionIndex], { isAnonymous: interaction.isAnonymous })
                };
                review = merge_1.default(review, reviewObject);
            }
            reviewsReceived.push(review);
        });
        let peerQuestionState = {
            userId,
            reviewsReceived,
            offerData: getOfferWithoutChildren(peerQuestion),
            children: []
        };
        peerQuestionState = addBaseFieldsToSession(peerQuestion, peerQuestionState);
        return peerQuestionState;
    }
    catch (error) {
        throw new Error('Error in convertToPeerQuestionMongoSession ' + error);
    }
}
function convertToPeerReviewMongoSession(peerReviewCard, assignmentCard, userId, allStates, stateInteractions) {
    try {
        let peerReviewState = getState_1.getStateByContentIdUserId(allStates, peerReviewCard._id, userId);
        peerReviewState = addBaseFieldsToSession(peerReviewCard, peerReviewState);
        const cardQuestionForReviewSessions = [];
        peerReviewCard.children.forEach((cardQuestionForReview) => {
            const correspondingCardQuestion = assignmentCard.children.find((cardQuestion) => cardQuestion._id === cardQuestionForReview.correspondingQuestionId);
            if (!correspondingCardQuestion) {
                return;
            }
            const cardQuestionState = getState_1.getStateByContentIdUserId(allStates, correspondingCardQuestion._id, userId);
            if (!cardQuestionState) {
                return;
            }
            const submissionId = cardQuestionState.submissions[0]._id;
            const cardQuestionForReviewState = getState_1.getStateByContentIdUserId(allStates, cardQuestionForReview._id, userId);
            const peerReviewStateInteractions = getStateInteraction_1.getPeerReviewStateInteractions(stateInteractions, correspondingCardQuestion._id, userId, submissionId);
            const peerQuestionSessions = cardQuestionForReview.children.map((peerQuestion, peerQuestionIndex) => convertToPeerQuestionMongoSession(peerQuestionIndex, userId, peerQuestion, peerReviewStateInteractions));
            const cardQuestionForReviewSession = Object.assign({}, cardQuestionForReviewState, { userId, offerData: getOfferWithoutChildren(cardQuestionForReview), children: peerQuestionSessions });
            cardQuestionForReviewSessions.push(cardQuestionForReviewSession);
        });
        const peerReviewSession = Object.assign({}, peerReviewState, { userId, offerData: getOfferWithoutChildren(peerReviewCard), children: cardQuestionForReviewSessions });
        return peerReviewSession;
    }
    catch (error) {
        throw new Error('Error in toPeerReviewMongoSession ' + error);
    }
}
function mergeFeedbackToSubmission(userId, cardQuestionState, allStateInteractions, submission) {
    const feedbackInteractions = getStateInteraction_1.getFeedbackStateInteractions(allStateInteractions, cardQuestionState.contentId, userId, submission._id);
    for (const feedbackInteraction of feedbackInteractions) {
        if (!submission.feedbacks) {
            submission.feedbacks = [];
        }
        submission.feedbacks.push({
            feedback: feedbackInteraction.feedbackText,
            feedbackGivenBy: feedbackInteraction.actorId
        });
    }
    return submission;
}
function mergeGradeToSubmission(userId, cardQuestionState, allStateInteractions, submission) {
    try {
        const gradeInteractions = getStateInteraction_1.getGradeStateInteractions(allStateInteractions, cardQuestionState.contentId, userId, submission._id);
        for (const gradeInteraction of gradeInteractions) {
            submission.gradedBy = gradeInteraction.actorId;
        }
        return submission;
    }
    catch (error) {
        throw new Error('Error in mergeGradeToSubmission ' + error);
    }
}
function mergeSubmissionInteractions(userId, cardQuestionState, allStateInteractions) {
    try {
        for (let submission of cardQuestionState.submissions) {
            submission = mergeFeedbackToSubmission(userId, cardQuestionState, allStateInteractions, submission);
            submission = mergeGradeToSubmission(userId, cardQuestionState, allStateInteractions, submission);
        }
    }
    catch (error) {
        throw new Error('Error in mergeSubmissionInteractions ' + error);
    }
}
function convertAssignmentToMongoSession(assignmentCard, userId, allStates, allStateInteractions) {
    try {
        let assignmentState = getState_1.getStateByContentIdUserId(allStates, assignmentCard._id, userId);
        assignmentState = addBaseFieldsToSession(assignmentCard, assignmentState);
        const cardQuestionSessions = [];
        (assignmentCard.children || []).forEach((cardQuestion) => {
            let cardQuestionState = getState_1.getStateByContentIdUserId(allStates, cardQuestion._id, userId);
            if (cardQuestionState) {
                mergeSubmissionInteractions(userId, cardQuestionState, allStateInteractions);
            }
            cardQuestionState = addBaseFieldsToSession(cardQuestion, cardQuestionState);
            const cardQuestionSession = Object.assign({}, cardQuestionState, { userId, offerData: getOfferWithoutChildren(cardQuestion), children: [] });
            cardQuestionSessions.push(cardQuestionSession);
        });
        return Object.assign({}, assignmentState, { userId, offerData: getOfferWithoutChildren(assignmentCard), children: cardQuestionSessions });
    }
    catch (error) {
        throw new Error('Error in convertAssignmentToMongoSession ' + error);
    }
}
function convertCourseToMongoDoc(course, userId, allStates, allEnrolments) {
    try {
        let courseSession = getState_1.getStateByContentIdUserId(allStates, course._id, userId);
        if (!courseSession) {
            return undefined;
        }
        courseSession = addBaseFieldsToSession(course, courseSession);
        courseSession = Object.assign({}, courseSession, { userId, offerData: getOfferWithoutChildren(course), children: [] });
        addAssignInfoToSession(courseSession, userId, allEnrolments);
        return courseSession;
    }
    catch (error) {
        throw new Error('Error in convertCourseToMongoDoc ' + error);
    }
}
function convertSectionToMongoDoc(section, userId, allStates) {
    try {
        let sectionSession = getState_1.getStateByContentIdUserId(allStates, section._id, userId);
        sectionSession = addBaseFieldsToSession(section, sectionSession);
        return Object.assign({}, sectionSession, { offerData: getOfferWithoutChildren(section), children: [] });
    }
    catch (error) {
        throw new Error('Error in convertSectionToMongoDoc ' + error);
    }
}
function convertLearningCardToMongoSession(learningCard, userId, allStates) {
    try {
        let learningCardSession = getState_1.getStateByContentIdUserId(allStates, learningCard._id, userId);
        learningCardSession = addBaseFieldsToSession(learningCard, learningCardSession);
        return Object.assign({}, learningCardSession, { children: [], userId, offerData: getOfferWithoutChildren(learningCard) });
    }
    catch (error) {
        throw new Error('Error in convertLearningCardToMongoSession ' + error);
    }
}
function cardSessionToMongo(card, cardIndex, section, userId, allStates, allStateInteractions) {
    const cardContentType = getContentType_1.getContentType(card);
    let cardSession = {};
    switch (cardContentType) {
        case entity_1.ContentType.LEARNING_CARD:
            cardSession = convertLearningCardToMongoSession(card, userId, allStates);
            break;
        case entity_1.ContentType.ASSIGNMENT_CARD:
            cardSession = convertAssignmentToMongoSession(card, userId, allStates, allStateInteractions);
            break;
        case entity_1.ContentType.PEER_REVIEW_CARD: {
            const assignmentCard = section.children[cardIndex - 1];
            cardSession = convertToPeerReviewMongoSession(card, assignmentCard, userId, allStates, allStateInteractions);
            break;
        }
        default:
            break;
    }
    return cardSession;
}
const pushChildToSession = (session, childSession) => {
    if (!session.children) {
        session.children = [];
    }
    session.children.push(childSession);
};
function addAssignInfoToSession(courseSession, userId, allEnrolments) {
    const enrolment = getEnrolmentOfContent_1.default(allEnrolments, courseSession.offerData._id, userId);
    if (enrolment) {
        courseSession.deleted = enrolment.deleted;
        courseSession.direct = enrolment.direct;
        courseSession.curriculumOfferIds = enrolment.parentIds;
        courseSession.assignInfo = enrolment.enrolmentInfo;
    }
}
function addAssignInfoCurriculumSession(curriculumSession, userId, allEnrolments) {
    const enrolment = getEnrolmentOfContent_1.default(allEnrolments, curriculumSession.curriculumOfferData._id, userId);
    if (enrolment) {
        curriculumSession.deleted = enrolment.deleted;
        curriculumSession.direct = enrolment.direct;
        curriculumSession.curriculumOfferIds = [];
        curriculumSession.assignInfo = enrolment.enrolmentInfo;
    }
}
const isOfferOfCurriculum = (offer) => !offer.contentType || offer.contentType === 'offer';
const isActivityOfCurriculum = (offer) => !isOfferOfCurriculum(offer);
const getOfferIdsOfCurriculum = (content) => content.offers.filter(isOfferOfCurriculum).map((offer) => offer.offerId);
const getActivityIdsOfCurriculum = (content) => content.offers.filter(isActivityOfCurriculum).map((offer) => offer.offerId);
const findContent = (childContents, contentId) => childContents.find(offerContent => offerContent._id === contentId || offerContent.contentId === contentId);
function getSessionFromChildContents(childContents, offerId, userId, allStates, allEnrolments) {
    const offer = findContent(childContents, offerId);
    if (!offer) {
        return undefined;
    }
    const courseSession = convertCourseToMongoDoc(offer, userId, allStates, allEnrolments);
    return courseSession;
}
function getCourseSessionsOfCurriculum(content, childContents, userId, allStates, allEnrolments) {
    const offerIds = getOfferIdsOfCurriculum(content);
    const allOfferSession = offerIds
        .map((offerId) => getSessionFromChildContents(childContents, offerId, userId, allStates, allEnrolments))
        .filter(filterNullItem);
    return allOfferSession;
}
function addProgressStatusForIlt(state) {
    const progressStatus = getILTProgressStatusFromCompletionStatus_1.getILTProgressStatusFromCompletionStatus(state);
    return Object.assign({}, state, { progressStatus });
}
function addProgressStatusForCheckpoint(state) {
    let progressStatus = 'notSubmitted';
    switch (state.completionStatus) {
        case entity_1.CompletionStatus.COMPLETE:
            progressStatus = 'approved';
            break;
        case entity_1.CompletionStatus.INCOMPLETE: {
            const submission = state.submissions[0];
            if (submission.submissionStatus === 'rejected') {
                progressStatus = 'rejected';
            }
            progressStatus = 'pending';
            break;
        }
        case entity_1.CompletionStatus.NOT_ATTEMPTED:
            progressStatus = 'notSubmitted';
            break;
        default:
            break;
    }
    return Object.assign({}, state, { progressStatus });
}
function addMetaToIltState(state) {
    const meta = { registrationType: state.registrationType };
    return Object.assign({}, state, { meta });
}
const findReviewQuestionForQuestionId = (reviewQuestionId, allQuestions) => allQuestions.find(question => question.id === reviewQuestionId);
function getReviewQuestionResponses(reviewQuestions, evaluationStateInteraction) {
    const reviewQuestionResponses = [];
    (evaluationStateInteraction.reviews || []).map((review) => {
        let reviewQuestionResponse = { response: review.responseText };
        if (review.toReviewQuestionId) {
            const reviewQuestion = findReviewQuestionForQuestionId(review.toReviewQuestionId, reviewQuestions);
            reviewQuestionResponse = Object.assign({}, reviewQuestionResponse, reviewQuestion);
        }
        reviewQuestionResponses.push(reviewQuestionResponse);
    });
    return reviewQuestionResponses;
}
function getReviewsOnSubmission(content, userId, submission, allStateInteractions) {
    const contentId = content._id || content.contentId;
    const evaluationStateInteractions = getStateInteraction_1.getEvaluationStateInteractions(allStateInteractions, contentId, userId, submission.submissionId);
    const reviewQuestions = content.meta ? content.meta.reviewQuestions || [] : [];
    const reviews = [];
    evaluationStateInteractions.forEach((evaluationStateInteraction) => {
        const reviewQuestionResponses = getReviewQuestionResponses(reviewQuestions, evaluationStateInteraction);
        const reviewObj = {
            reviewQuestions: reviewQuestionResponses,
            reviewedOn: evaluationStateInteraction.createdAt,
            reviewerId: evaluationStateInteraction.actorId,
            reviewerMessage: evaluationStateInteraction.feedbackText || ''
        };
        const transformedReview = Object.assign({}, reviewObj);
        reviews.push(transformedReview);
    });
    return reviews;
}
function convertSubmissionsForCheckpoint(content, userId, state, allStateInteractions) {
    const newSubmissions = state.submissions.map((submission) => {
        const reviews = getReviewsOnSubmission(content, userId, submission, allStateInteractions);
        const newSubmission = Object.assign({}, submission, { reviews });
        return newSubmission;
    });
    return newSubmissions;
}
function addMetaToCheckpointState(content, userId, state, allStateInteractions) {
    const submissions = convertSubmissionsForCheckpoint(content, userId, state, allStateInteractions);
    const meta = { submissions };
    return Object.assign({}, state, { meta });
}
function addFieldsForCheckpoint(content, userId, state, allStateInteractions) {
    state = addProgressStatusForCheckpoint(state);
    state = addMetaToCheckpointState(content, userId, state, allStateInteractions);
    return state;
}
function convertCheckpointToMongoDoc(content, userId, allStates, allStateInteractions) {
    const contentId = content._id || content.contentId;
    let state = Object.assign({}, getState_1.getStateByContentIdUserId(allStates, contentId, userId));
    if (isEmptyObject_1.default(state)) {
        return undefined;
    }
    state = Object.assign(state, { modelType: 'state' }, { userId });
    state = addBaseFieldsToSession(content, state);
    state = addFieldsForCheckpoint(content, userId, state, allStateInteractions);
    return state;
}
function addFieldsForIlt(state) {
    state = addProgressStatusForIlt(state);
    state = addMetaToIltState(state);
    return state;
}
function convertIltToMongoDoc(content, userId, allStates) {
    const contentId = content._id || content.contentId;
    let state = Object.assign({}, getState_1.getStateByContentIdUserId(allStates, contentId, userId));
    if (isEmptyObject_1.default(state)) {
        return undefined;
    }
    state = Object.assign(state, { modelType: 'state' }, { userId });
    state = addFieldsForIlt(state);
    return state;
}
function convertActivityToMongoDoc(content, userId, allStates, allStateInteractions) {
    try {
        const contentType = getContentType_1.getContentType(content);
        switch (contentType) {
            case entity_1.ContentType.CHECKPOINT:
                return convertCheckpointToMongoDoc(content, userId, allStates, allStateInteractions);
            case entity_1.ContentType.ILT:
                return convertIltToMongoDoc(content, userId, allStates);
            default:
                throw new Error('Invalid Type ' + contentType);
        }
    }
    catch (error) {
        throw new Error('Error in convertActivityToMongoDoc ' + error);
    }
}
function getStatesOfCurriculum(content, childContents, userId, allStates, allStateInteractions) {
    const activityIds = getActivityIdsOfCurriculum(content);
    const states = activityIds.map((activityId) => {
        const activity = findContent(childContents, activityId);
        if (activity) {
            return convertActivityToMongoDoc(activity, userId, allStates, allStateInteractions);
        }
        else {
            return undefined;
        }
    });
    return states.filter(filterNullItem);
}
function convertCurriculumToMongoDoc(content, childContents, userId, allStates, allStateInteractions, allEnrolments) {
    try {
        let curriculumSession = getState_1.getStateByContentIdUserId(allStates, content._id, userId);
        curriculumSession = addBaseFieldsToSession(content, curriculumSession);
        const sessions = getCourseSessionsOfCurriculum(content, childContents, userId, allStates, allEnrolments);
        const states = getStatesOfCurriculum(content, childContents, userId, allStates, allStateInteractions);
        return Object.assign({}, curriculumSession, { userId,
            sessions,
            states, curriculumOfferData: content });
    }
    catch (error) {
        throw new Error('Error in convertCurriculumToMongoDoc ' + error);
    }
}
function courseDynamoToMongoDoc(content, user, allStates, allStateInteractions, allEnrolments) {
    try {
        validateUser_1.validateUser(user, { caller: 'courseDynamoToMongoDoc' });
        const { userId } = user;
        const nonExistingDummyStates = addRemoveNonUpdatedStates_1.getDummyNonExistingStates(allStates, [content], user);
        allStates = allStates.concat(nonExistingDummyStates);
        const courseSession = convertCourseToMongoDoc(content, userId, allStates, allEnrolments);
        if (!courseSession) {
            return undefined;
        }
        for (const [, section] of (content.children || []).entries()) {
            const sectionSession = convertSectionToMongoDoc(section, userId, allStates);
            for (const [cardIndex, card] of (section.children || []).entries()) {
                const cardSession = cardSessionToMongo(card, cardIndex, section, userId, allStates, allStateInteractions);
                pushChildToSession(sectionSession, cardSession);
            }
            pushChildToSession(courseSession, sectionSession);
        }
        return courseSession;
    }
    catch (error) {
        throw new Error('Error in dynamoToMongoDoc ' + error);
    }
}
exports.courseDynamoToMongoDoc = courseDynamoToMongoDoc;
function curriculumDynamoToMongoDoc(content, childContents, user, allStates, allStateInteractions, allEnrolments) {
    try {
        validateUser_1.validateUser(user, { caller: 'curriculumDynamoToMongoDoc' });
        const { userId } = user;
        const nonExistingDummyStates = addRemoveNonUpdatedStates_1.getDummyNonExistingStates(allStates, [...childContents, content], user);
        allStates = allStates.concat(nonExistingDummyStates);
        const curriculumSession = convertCurriculumToMongoDoc(content, childContents, userId, allStates, allStateInteractions, allEnrolments);
        addAssignInfoCurriculumSession(curriculumSession, userId, allEnrolments);
        return curriculumSession;
    }
    catch (error) {
        throw new Error('Error in curriculumDynamoToMongoDoc ' + error);
    }
}
exports.curriculumDynamoToMongoDoc = curriculumDynamoToMongoDoc;
function checkpointDynamoToMongoDoc(content, user, allStates, allStateInteractions) {
    try {
        validateUser_1.validateUser(user, { caller: 'checkpointDynamoToMongoDoc' });
        const { userId } = user;
        const checkpointSession = convertCheckpointToMongoDoc(content, userId, allStates, allStateInteractions);
        return checkpointSession;
    }
    catch (error) {
        throw new Error('Error in checkpointDynamoToMongoDoc ' + error);
    }
}
exports.checkpointDynamoToMongoDoc = checkpointDynamoToMongoDoc;
function IltDynamoToMongoDoc(content, user, allStates) {
    try {
        validateUser_1.validateUser(user, { caller: 'IltDynamoToMongoDoc' });
        const { userId } = user;
        const iltSession = convertIltToMongoDoc(content, userId, allStates);
        return iltSession;
    }
    catch (error) {
        throw new Error('Error in IltDynamoToMongoDoc ' + error);
    }
}
exports.IltDynamoToMongoDoc = IltDynamoToMongoDoc;
//# sourceMappingURL=index.js.map